"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatMarsTheory = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Tags_1 = require("../Tags");
var CardRequirements_1 = require("../CardRequirements");
var Resources_1 = require("../../Resources");
var Options_1 = require("../Options");
var FlatMarsTheory = (function (_super) {
    __extends(FlatMarsTheory, _super);
    function FlatMarsTheory() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.FLAT_MARS_THEORY,
            cost: 8,
            tags: [Tags_1.Tags.EARTH],
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE, 1, { max: Options_1.max }); }),
            metadata: {
                cardNumber: 'Pf39',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.megacredits(1); }).slash().text('GENERATION');
                }),
                description: 'Requires maximum 1 science tag. Increase your MC production 1 step for every generation played so far.',
            },
        }) || this;
    }
    FlatMarsTheory.prototype.play = function (player) {
        var generation = player.game.generation;
        player.addProduction(Resources_1.Resources.MEGACREDITS, generation, { log: true });
        return undefined;
    };
    return FlatMarsTheory;
}(Card_1.Card));
exports.FlatMarsTheory = FlatMarsTheory;
